import React, {useEffect, useState} from "react";
import "../Dashboard/notification.css";
import "../Dashboard/Sidebar.js";
import Header from "../layout/header";
import BottomMenu from "../layout/bottomMenu";
import DashboardMenu from "../layout/dashboardMenu";
import Loader from "../../Loader/Loader";
import Moment from "moment";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../Images/not-notification.webp";

const Notifications = ({
                           getNotification,
                           notificationDetails = [],
                           history
                       }) => {

    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getNotification()
            setIsLoading(false)
        })()
    }, []);

    const onPageChange = async (val) => {
        setIsLoading(true)
        await getNotification(val?.selected + 1)
        setIsLoading(false)
    };

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            history={history}
                            title={'Notification'}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between mb-2">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px">
                                            <h1 className="h3 mb-0 text-black-100">Notifications <i
                                                className="fa fa-bell text-muted"></i></h1>
                                        </div>
                                    </div>
                                </div>

                                <div className="row notification-lists mt-20px">
                                    <div className="col-md-12">
                                        <div className="notification-ui_dd-content">
                                            {notificationDetails && notificationDetails?.data !== undefined && notificationDetails?.data.map((val, i) => {
                                                return (
                                                    <>
                                                        <div className="notification-list notification-list--unread">
                                                            <div className="notification-list_content">
                                                                {/* <div class="notification-list_img"> <img src="images/users/user1.jpg" alt="user" /> </div> */}
                                                                <div className="notification-list_detail">
                                                                    <p className="green"><b
                                                                        className="title-color">{val?.title}</b></p>
                                                                    <p className="text-muted">{val?.description}.</p>
                                                                    <p className="text-muted">
                                                                        <small><i>{Moment(val?.created_at).format('DD-MMMM-YYYY')} ({val?.send_from})</i></small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <a href={val?.link}>
                                                                <div className="notification-list_feature-img"><i
                                                                    className="bi bi-eye title-color"></i></div>
                                                            </a>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                            {notificationDetails && notificationDetails?.data !== undefined && notificationDetails?.data.length > 0 &&
                                                <div className="panel-pagination-col panel-table-pagination">
                                                    <ReactPaginate
                                                        previousLabel={'<'}
                                                        nextLabel={'>'}
                                                        breakLabel={'...'}
                                                        breakClassName={'break-me'}
                                                        pageCount={(notificationDetails?.total / notificationDetails?.per_page)}
                                                        forcePage={notificationDetails?.current_page-1}
                                                        pageRangeDisplayed={4}
                                                        onPageChange={onPageChange}
                                                        activeClassName={'active'}
                                                    />
                                                </div>
                                            }
                                            {notificationDetails && notificationDetails?.data !== undefined && notificationDetails?.data.length === 0 &&
                                                <>
                                                    <div className="text-center" style={{"width": "100%"}}>
                                                      <img src={NotFoundData} className="not-found-data" alt={""}/><br/>
                                                        No Notification Found
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <BottomMenu/>
            </div>
            {/* section ends */}
        </>
    )
}

export default Notifications